export default __webpack_public_path__ + "JOL_IpadStockPhoto.348323b364b681c017c7729601ba44f9.jpg";